import { FB_Template } from '@algomusinc/domain';
import { ColDef } from 'ag-grid-enterprise';
import { calcForecastMeasuresGDP } from './calcForecastMeasuresGDP';
import { calcForecastMeasuresRDP } from './calcForecastMeasuresRDP';
import { getMeasureFormattedValue } from './getMeasureFormattedValue';

function parseExportValue(formatedValue: any): any {
  if (typeof formatedValue !== 'string') {
    return formatedValue;
  }
  const stripped = formatedValue.replace(/[^\d.-]/g, '');
  const parsed = parseFloat(stripped);
  return isNaN(parsed) ? formatedValue : parsed;
}

function isNumericExportMeasure(measureConfig: any): boolean {
  return !!measureConfig && (
    measureConfig.isCurrency ||
    measureConfig.isPercent ||
    measureConfig.isSplitPercent ||
    measureConfig.isDecimal ||
    measureConfig.isRoundOff
  );
}

export const exportCurrentView = (
  baseAgGridWrapper: any,
  baseGrid: any,
  accountList: any,
  Workbook: any,
  itemsList: any,
  fs: any,
  dcBaseAgGridWrapper?: any
) => {
  let itemLabel =  baseGrid.selectedNavProduct ? baseGrid.selectedNavProduct.label ||  baseGrid.selectedNavProduct.label: 'All Item(s)';
  let accountLabel =  baseGrid.selectedNavAccount ? baseGrid.selectedNavAccount.label: 'All Location(s)';
  if (!baseGrid.singleNavigation) {
    if (baseGrid.selectedAccountNodes && baseGrid.selectedAccountNodes.length > 0) {
      const nodesLength = baseGrid.selectedAccountNodes.filter((row: any) => row.leaf).length;
      accountLabel = `Multi-Select`;
    }
    if (baseGrid.selectedItemNodes && baseGrid.selectedItemNodes.length > 0) {
      const nodesLength = baseGrid.selectedItemNodes.filter((row: any) => row.leaf).length;
      itemLabel = `Multi-Select`;
    }
  }
  let currentUIList:any=[]
  // if(baseAgGridWrapper.fbTemplateId==FB_Template.Split_Percentage){
  //   const baseGrid = JSON.parse(
  //     JSON.stringify(baseAgGridWrapper.baseGrid.uiList)
  //   );
  //   currentUIList.push(...baseGrid);
  //   if(baseAgGridWrapper.baseGrid.groupNo < 3){
  //     let splitPercentGrid :any = []
  //     splitPercentGrid = baseAgGridWrapper.baseGrid.splitPercentGrid.uiList;
  //     splitPercentGrid.push(...baseAgGridWrapper.baseGrid.splitPercentGrid.pinnedBottomRowData);
  //     console.log(splitPercentGrid);
  //     splitPercentGrid =JSON.parse(
  //     JSON.stringify(splitPercentGrid)
  //     )
  //     currentUIList.push(...splitPercentGrid);
  //     let splitPercentValueGrid :any = []
  //     splitPercentValueGrid = baseAgGridWrapper.baseGrid.splitPercentValueGrid.uiList;
  //     splitPercentValueGrid.push(...baseAgGridWrapper.baseGrid.splitPercentValueGrid.pinnedBottomRowData);
  //     console.log(splitPercentValueGrid);
  //     splitPercentValueGrid =JSON.parse(
  //     JSON.stringify(splitPercentValueGrid)
  //     )
  //     currentUIList.push(...splitPercentValueGrid)
  //   }else{
  //     const accessoriesUiList :any = []
  //     baseAgGridWrapper.baseGrid.splitAccessoriesGrids.forEach((element:any) => {
  //       accessoriesUiList.push(...element.uiList);
  //       accessoriesUiList.push(...element.pinnedBottomRowData);
  //     });
  //     currentUIList.push(...accessoriesUiList)
  //   }

  // }
  // else{
    currentUIList = JSON.parse(
      JSON.stringify(baseAgGridWrapper.baseGrid.uiList)
    );
  // }
  const currentItem: any = itemsList.find(
    (row: any) => row.label == itemLabel
  );
  const currentAccount: any = accountList.find(
    (row: any) => row.accountName == accountLabel
  );
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('Grid Data');
  const columns = getColumnDefs(baseAgGridWrapper.fbTemplateId ,  baseAgGridWrapper.baseGrid.isTransposeView);
  const columnDefs = baseAgGridWrapper.baseGrid.gridApi
    .getColumnDefs()
    ?.filter((row: any) => row.headerName && !row.hide);
  if (columnDefs && columnDefs.length > 0) {
    columnDefs.forEach((el: ColDef) => {
      const calendar = {
        header: el.headerName,
        key: baseAgGridWrapper.baseGrid.isTransposeView ? el.field :  el.headerName,
        width: 20,
        style: {
          numFmt: '#,##0.00',
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
        },
      };
      columns.push(calendar as any);
    });
  }
  let commulativeList: any[] = [];
  if([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(baseAgGridWrapper.fbTemplateId)){
    let currentList:any=[]
    let ItemAccount = currentUIList.map((e:any)=>e.itemAccountName);
    ItemAccount = [...new Set(ItemAccount)];
    ItemAccount.forEach((element:any) => {
      let uiList = currentUIList.filter((e:any)=>e.itemAccountName == element)
      currentList.push({
        ItemAccount : element,
         isEmptyRow : true,
        isSelected: true,
        measureName : '',
        id : '',
        code : '',
        isChecked : true,
      });
      currentList.push(...uiList);
    });

    currentUIList = currentList;
  }
  else{
    currentUIList.forEach((row: any) => {
      if(!row.isEmptyRow){
        row.sku = currentItem && currentItem.isRoot ? currentItem.key ? currentItem.key : '': itemLabel;
        row.description = currentItem ? currentItem.name: itemLabel;
        row.channelId = '';
        row.account = currentAccount ? currentAccount.salesforceId: accountLabel
        row.accountName = currentAccount ? currentAccount.accountName: accountLabel
      }
    });
  } 
  currentUIList.forEach((row: any) => {
    Object.keys(row).forEach((key) => {
      if(baseAgGridWrapper.baseGrid.isTransposeView){
        let measure = columnDefs.find((col:any)=> col.field === key)
        if (measure) {
          const column = {
            value: row[key],
            colDef: {
              field: key,
            },
            data: {...row,...measure.refData},
          };
          let formatedValue: any = getMeasureFormattedValue(column,baseGrid)
          if ((formatedValue === '' || formatedValue === undefined || formatedValue === null) && column.value !== undefined && column.value !== null) {
            formatedValue = column.value;
          }

          if (isNumericExportMeasure(measure.refData.measureConfigData) && column.value !== 'Multiple' && formatedValue !== 'Multiple') {
            row[key] = parseExportValue(formatedValue);
          } else {
            row[key] = formatedValue;
          }
        }
      }
      else{
        if (baseAgGridWrapper.baseGrid.selectedTimeframe.includes(key)) {
        let colMeasure = columnDefs.find((col: any) => col.field === key && col.refData);
        const column = {
          value: row[key],
          colDef: {
            field: key,
          },
          data: colMeasure ? { ...row, ...colMeasure.refData } : row,
        };
        let formatedValue: any = getMeasureFormattedValue(column,baseGrid)
        if ((formatedValue === '' || formatedValue === undefined || formatedValue === null) && column.value !== undefined && column.value !== null) {
          formatedValue = column.value;
        }

        if (isNumericExportMeasure(column.data.measureConfigData) && column.value !== 'Multiple' && formatedValue !== 'Multiple') {
          row[key] = parseExportValue(formatedValue);
        } else {
          row[key] = formatedValue;
        }
      }
      }
      
    });
  });
  commulativeList = [...currentUIList.filter((row: any) => row.isChecked)];
  worksheet.columns = columns as any;
  commulativeList.forEach((e) => {
    worksheet.addRow(e, 'n');
  });
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  if (dcBaseAgGridWrapper && dcBaseAgGridWrapper.baseGrid && dcBaseAgGridWrapper.baseGrid.uiList) {
    let dcUIList: any = JSON.parse(
      JSON.stringify(dcBaseAgGridWrapper.baseGrid.uiList)
    );
    const dcWorksheet = workbook.addWorksheet('DC Grid Data');
    const dcColumns = getColumnDefs(dcBaseAgGridWrapper.fbTemplateId ?? baseAgGridWrapper.fbTemplateId, dcBaseAgGridWrapper.baseGrid.isTransposeView);
    const dcColumnDefs = dcBaseAgGridWrapper.baseGrid.gridApi
      ?.getColumnDefs()
      ?.filter((row: any) => row.headerName && !row.hide);
    if (dcColumnDefs && dcColumnDefs.length > 0) {
      dcColumnDefs.forEach((el: ColDef) => {
        const calendar = {
          header: el.headerName,
          key: dcBaseAgGridWrapper.baseGrid.isTransposeView ? el.field : el.headerName,
          width: 20,
          style: {
            numFmt: '#,##0.00',
            border: {
              top: { style: 'thin', color: { argb: '000000' } },
              left: { style: 'thin', color: { argb: '000000' } },
              bottom: { style: 'thin', color: { argb: '000000' } },
              right: { style: 'thin', color: { argb: '000000' } },
            },
          },
        };
        dcColumns.push(calendar as any);
      });
    }

    // Group by itemAccountName for MIV-style DC grids
    let dcCurrentList: any[] = [];
    let dcItemAccount = dcUIList.map((e: any) => e.itemAccountName);
    dcItemAccount = [...new Set(dcItemAccount)];
    dcItemAccount.forEach((element: any) => {
      let uiList = dcUIList.filter((e: any) => e.itemAccountName == element);
      dcCurrentList.push({
        ItemAccount: element,
        isEmptyRow: true,
        isSelected: true,
        measureName: '',
        id: '',
        code: '',
        isChecked: true,
      });
      dcCurrentList.push(...uiList);
    });
    dcUIList = dcCurrentList;

    // Format values
    dcUIList.forEach((row: any) => {
      Object.keys(row).forEach((key) => {
        if (dcBaseAgGridWrapper.baseGrid.isTransposeView) {
          let measure = dcColumnDefs?.find((col: any) => col.field === key);
          if (measure) {
            const column = {
              value: row[key],
              colDef: { field: key },
              data: { ...row, ...measure.refData },
            };
            let formatedValue: any = getMeasureFormattedValue(column, dcBaseAgGridWrapper.baseGrid);
            if ((formatedValue === '' || formatedValue === undefined || formatedValue === null) && column.value !== undefined && column.value !== null) {
              formatedValue = column.value;
            }
            if (isNumericExportMeasure(measure.refData.measureConfigData) && column.value !== 'Multiple' && formatedValue !== 'Multiple') {
              row[key] = parseExportValue(formatedValue);
            } else {
              row[key] = formatedValue;
            }
          }
        } else {
          if (dcBaseAgGridWrapper.baseGrid.selectedTimeframe?.includes(key)) {
            let colMeasure = dcColumnDefs?.find((col: any) => col.field === key && col.refData);
            const column = {
              value: row[key],
              colDef: { field: key },
              data: colMeasure ? { ...row, ...colMeasure.refData } : row,
            };
            let formatedValue: any = getMeasureFormattedValue(column, dcBaseAgGridWrapper.baseGrid);
            if ((formatedValue === '' || formatedValue === undefined || formatedValue === null) && column.value !== undefined && column.value !== null) {
              formatedValue = column.value;
            }
            if (isNumericExportMeasure(column.data.measureConfigData) && column.value !== 'Multiple' && formatedValue !== 'Multiple') {
              row[key] = parseExportValue(formatedValue);
            } else {
              row[key] = formatedValue;
            }
          }
        }
      });
    });

    const dcCommulativeList = [...dcUIList.filter((row: any) => row.isChecked)];
    dcWorksheet.columns = dcColumns as any;
    dcCommulativeList.forEach((e: any) => {
      dcWorksheet.addRow(e, 'n');
    });
    dcWorksheet.getRow(1).font = { bold: true };
    dcWorksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' },
    };
  }

  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    if(baseAgGridWrapper.fbTemplateId === FB_Template.REPL_PLANNER)
    {
      fs.saveAs(blob, `REPLENISHMENT_${baseAgGridWrapper.jobUserId}.xlsx`);
    }else {
      fs.saveAs(blob, `Forecast${new Date().toISOString()}.xlsx`);
    }
  });
};


function getColumnDefs(fbTemplateId: number , isTransposeView:boolean = false) {
  let columns;
  if([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(fbTemplateId)){
    columns = [
      {
        header: 'Item-Account',
        key: 'ItemAccount',
        width: 50,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
      {
        header: isTransposeView ? 'Week' : 'Measure',
        key: isTransposeView ? 'id' :'measureName',
        width: 50,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
    ];
  }else{
    columns = [
      {
        header: 'Measure',
        key: 'measureName',
        width: 50,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
      {
        header: 'SKU',
        key: 'sku',
        width: 20,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
      {
        header: 'Description',
        key: 'description',
        width: 20,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
      {
        header: 'Account Name',
        key: 'accountName',
        width: 20,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
      {
        header: 'Account',
        key: 'account',
        width: 20,
        style: {
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
          fill: {
            type: 'pattern',
            gradient: 'lightGray',
            bgColor: { argb: '808080' },
          },
        },
      },
    ];
  }
  return columns;
}
